<template>
  <div id="credit_card2" class="description collapse show">
    <div class="form-container active">
      <form id="card_form" action="" class="card-form">
        <div class="form-group">
          <div class="card-wrapper">
            <stripe-card
              class="stripe-card"
              :class="{ complete }"
              :stripe="method.client_side_gateway.pub_api_key"
              @change="complete = $event.complete"
            />
          </div>

          <span v-show="stripeError" class="help is-danger">{{
            stripeError
          }}</span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import StripeCard from "@/components/stripe/Card";

export default {
  name: "StripePayment",

  components: { StripeCard },
  props: {
    method: {
      type: Object,
      default: function () {
        return {
          gateway: "creditcard",
          client_side_gateway: null,
        };
      },
    },
  },

  data: function () {
    return {
      stripeError: null,
      complete: false,
    };
  },
};
</script>
